import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';

const Profissional = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchProfissionais()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    const ver = async (id) => {
        props.ver(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        {props.profissional.foto ? 
                        <Fragment>
                            <img className="foto-prof" src={props.profissional.foto} />
                        </Fragment>
                        : null}
                        <Card.Title className="cabeca-card" key={props.key}>{props.profissional.nome} / {props.profissional.especialidade}</Card.Title>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.profissional._id)} variant='primary'>Editar</Button>
                    <Button type="button" className="botao-leis" onClick={() => ver(props.profissional._id)} variant='warning'>Locais e Horários</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.profissional._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Profissional;